import gql from 'graphql-tag';

const pendingReturnInvoicesQuery = gql`
  query pendingReturnInvoices(
    $dealerNumber: String
    $vin: String
    $vra: String
    $size: Int
    $offset: Int
  ) {
    pendingReturnInvoices(
      dealerNumber: $dealerNumber
      vin: $vin
      vra: $vra
      size: $size
      offset: $offset
    ) {
      id
      odometerOnReturn
      returnInitiatedAt
      expirationDate
      transaction {
        id
        purchasePrice
      }
      auctionLocation {
        name
      }
      returningUser {
        id
        username
        email
      }
      pendingReasons {
        id
        code
        notice
      }
      guaranteePurchase {
        id
        guaranteeOffer {
          id
          dealerName
          vehicleInformation {
            id
            vin
          }
          auctionInformation {
            id
            dealerNumber
          }
        }
      }
    }
  }
`;

export default pendingReturnInvoicesQuery;
